import React from 'react';
import { CalendarIcon, ChevronDownIcon } from 'lucide-react';
import { rangeOptions } from '../../utils/range';
import type { DateRange } from '../../types/voip';
interface RangeSelectProps {
  value: DateRange;
  onChange: (range: DateRange) => void;
}
export function RangeSelect({
  value,
  onChange
}: RangeSelectProps) {
  return <label className="relative inline-flex" data-id="element-127" data-mp="wmlsio4psv44">
      <span className="sr-only" data-id="element-128" data-mp="hr5ru09mq0yr">Date range</span>
      <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-129" data-mp="hpcmcoar5msc" />
      <select value={value} onChange={e => onChange(e.target.value as DateRange)} className="appearance-none rounded-xl border border-line bg-surface py-2 pl-9 pr-9 text-[13px] font-medium text-ink shadow-card transition-colors duration-150 ease-out hover:border-accent/30 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/15" data-id="element-130" data-mp="mnmhiywh8ndy">
        {rangeOptions.map(o => <option key={o.value} value={o.value} data-id="element-131" data-mp="1qufj7iu6yl7s">
            {o.label}
          </option>)}
      </select>
      <ChevronDownIcon className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-subtle" aria-hidden data-id="element-132" data-mp="1mtlx8v0b7ghj" />
    </label>;
}